module.exports = __webpack_public_path__ + "static/Home_Header-min-0fb0d5d6023ba47a6fa28450c8c521fb.jpg";